
import React from 'react';
import Baner from '../components/Baner';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Why from '../components/Why';

const Home = () => {
    return (
        <React.Fragment>
            <Hero />
            <div className='container'>
                <div >
                    <h2>Ayudate a ti mismo a superar la agorafobia</h2>
                <div className="whys">
                    <Why  texto="Ejercicios centrados en la autoconfianza"/>
                    <Why  texto="A tu ritmo y tiempo"/>
                    <Why  texto="ejercicios de autocontrol diarios"/>
                    <Why  texto="Retos que demostraran lo muchos que haz avanzado"/>
                </div>
                </div>
                <h2>Creada por agorafobicos</h2>
                <p>A diferencia de otras Aplicaciones, XXXX esta creada por agorafobicos, es decir que sabemos por lo que pasas.</p>
                <p>El sistema esta pensado para ayudarte en 3 areas:
                    <li>Pensamiento</li>
                    <li>Sensaciones</li>
                    <li>Comportamientos</li>
                </p>
                <h2>Como funciona? y porque deberias darte una oportunidad?</h2>
                <div className="flex"><img src="./img/tratamiento-online.jpg" alt="" />
                <div>
                     <p>Puedo apostar que en muchas ocaciones, por no decir siempre, haz sentido esa
                    incomoda pelota en la cabeza. Esa sensacion de tener en la cabeza un tumor.
                </p>
                <p>Seguramente hayas ido al medico y no haya encontrado nada. Los medicamentos no hacen nada.
                    Ahora que pasa si con tus dedos, de forma suave, tiras de hacia abajo de la piel de tus cejas. 
                </p>  
                </div>
                 
                </div>
                
                
                <p>El tumor pasa a ser un sensacion nueva, ahora sentiras otra cosa. Felicidades acabas de pasar de "Tengo un tumor cerebral" a "Eso no lo habia sentido antes."</p>
                <h3>Cambiar la mente para curar la mente</h3>
                <p>En base a experimentar sobre tu propio cuerpo, iras aprendiendo como este responde los estimulos. Porque te mareas, porque tu boca se seca, porque
                    te duele el abdomen, porque sientes que te caes.
                </p>
                <p>Replicaremos todos y cada unos de los sintomas, para demostrarte a ti mismo que no hay nada que temer.
                    Siempre en un lugar seguro, en el que tu siempre tienes el control. 
                </p>
                <h3>Pierde el miedo a volar</h3>
                <div className='flex'>
                    <div>
                        <p>Te han dicho "Es que eres tu el que exagera"? Pues tienen razon, pero no es tu culpa,
                    En esta etapa vamos minificando los sintomas llevando registro de ellos.
                </p>
                <p>Veras com en pocos dias pasas de "volverte loca" a "mis oidos se desajustan caundo me tenso".</p>
                <p>Iras desglosando los sintomas, viendo como estos interactuan entre si y como desactivando uno desactivas todos.</p> 
                    </div>
                    <img src="./img/agorafobia.jpg" alt="" />
                </div>
               
                <Baner/>
            </div>  
            <Footer />
        </React.Fragment>
    );
};

export default Home;